var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-readsignagree",attrs:{"id":"app-readsignagree"}},[_c('myLegalNotice',{attrs:{"mln_id":'forsignagree',"mini-show":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }